import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.submitEndHandler = this.reset.bind(this)
    this.element.addEventListener("turbo:submit-end", this.submitEndHandler)
    this.submitting = false
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.submitEndHandler)
  }

  submit() {
    if (this.submitting) return

    const form = this.element.closest("form") || this.element

    // Guard against missing form or non-form elements
    if (!form || typeof form.requestSubmit !== "function") {
      return
    }

    // Check form validity before setting submitting flag
    if (form.checkValidity && !form.checkValidity()) {
      form.reportValidity()
      return
    }

    this.submitting = true
    form.requestSubmit()
  }

  reset() {
    this.submitting = false
  }
}
